// Centralized constants for the standalone Family Lines experience (DSC-10385).
// Update FAMILY_LINES_BASE_PATH to change the root route for the experience.
export const FAMILY_LINES_BASE_PATH = '/family-lines'
